import classnames from 'classnames'
import { type FC } from 'react'
import type { IAudioPlayerSummaryItem } from 'shared/ui/AudioPlayer'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IAISummaryContentProps = {
  items: IAudioPlayerSummaryItem[]
}

export const AISummaryContent: FC<IAISummaryContentProps> = ({ items }) => {
  if (!items.length) {
    return (
      <Typography
        className={classnames(styles.wrap, styles['wrap--center'])}
        tag={'div'}
        variant={'body-rg-regular'}
        ariaLabel={'AISummaryGroup_item'}
      >
        No result
      </Typography>
    )
  }

  return (
    <div className={styles.wrap}>
      {items.map((group) => {
        return (
          <div key={group.id} className={styles.group}>
            <Typography
              tag={'div'}
              variant={'body-rg-semibold'}
              ariaLabel={'AISummaryGroup'}
              className={styles.group__title}
            >
              {group.title}:
            </Typography>

            <ul className={styles.group__items}>
              {group.items.map((item) => {
                return (
                  <li key={item.id}>
                    <Typography
                      variant={'body-rg-regular'}
                      ariaLabel={'AISummaryGroup_item'}
                      className={styles.group__item}
                    >
                      {item.text}
                    </Typography>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })}
    </div>
  )
}
